module.exports = ["Auction","YourCollectible"];